<template>
  <div>
    <div class="contact-info">
      <el-descriptions title="联系人信息" v-if="contactDetail">
        <el-descriptions-item label="姓名：">{{contactDetail.name}}</el-descriptions-item>
        <el-descriptions-item label="性别：">
          {{ SexOption.find((k: any) => k.id === contactDetail.sex) ? SexOption.find((k: any) => k.id === contactDetail.sex).mark : ''}}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话：">{{contactDetail.phone}}</el-descriptions-item>
        <el-descriptions-item label="邮箱：">{{contactDetail.email}}</el-descriptions-item>
      </el-descriptions>
      <div style="text-align:right">
        <el-button
          class="filter-item"
          type="primary"
          @click="handleCommand('add')"
        >
          新建
        </el-button>
      </div>
      <TableList
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :handleDefaultWidth="150"
        :maxHight="300"
        @command-change="handleCommand"
      >
         <template v-slot:operation-action="scope">
          <el-link
            v-if="!scope.row.isEidt"
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            编辑
          </el-link>
          <el-link
            v-if="scope.row.isEidt"
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('save', scope.row)"
          >
            保存
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_SETDEFAULT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('setDefaul', scope.row)"
          >
            设置默认账户
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_DELETE` }"
            href="javascript:void(0);"
            type="danger"
            @click="handleCommand('delete', scope.row)"
          >
            删除
          </el-link>
         </template>
      </TableList>
    </div>
  </div>
</template>
<script lang='ts'>
import { useI18n } from 'vue-i18n'
import { defineComponent, watch, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getCompanyContactById } from '@/apis/CustomerCompanyContact'
import { getContactPayList, deleteContactPayById, setDefaultContactPay, createContactPay, updateContactPay } from '@/apis/CustomerCompanyContactPay'
import { getDropdownByType } from '@/apis/tool'

import { cloneDeep } from 'lodash'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'

import TableList from '@/components/common/TableList.vue'

export default defineComponent({
  name: 'Viewpay',
  components: {
    TableList
  },
  props: {
    contactId: { type: Number, default: 0, required: true }
  },
  emits: ['update:visible'],
  setup(props) {
    const { t } = useI18n()
    interface PayModel {
      id?: number;
      type: string | number;
      name: string;
      branchName: string;
      account: string;
      content: string;
      eidtForm?: object;
      [propName: string]: any;
    }
    const dataMap = reactive({
      TableName: TableName.TABLE_CUSTOMERCONTACTPAY,
      permissionName: permissionName.CUSTOMERCONTACTPAY,
      contactDetail: null,
      listLoading: false,
      fromFieldData: FromFieldData,
      list: [],
      columnAllData: TableField,
      initFormData: cloneDeep(FromFieldData),
      UserPayTypeOption: [],
      SexOption: [],
      isAnyOneEidt: false,

      getList() {
        dataMap.listLoading = true
        if (!props.contactId) {
          dataMap.list = []
          dataMap.listLoading = false
          return
        }
        getContactPayList({ contactId: props.contactId }).then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'save':
            dataMap.handleSave(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'setDefaul':
            dataMap.handleSetDefault(val)
            break
        }
      },
      handleCreate() {
        if (dataMap.isAnyOneEidt) {
          return
        }
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.isAnyOneEidt = true
        dataMap.list.push({
          type: '',
          name: '',
          branchName: '',
          account: '',
          content: '',
          isEidt: true,
          eidtForm: dataMap.fromFieldData
        })
      },
      handleUpdate(row: any) {
        if (dataMap.isAnyOneEidt) {
          return
        }
        dataMap.isAnyOneEidt = true
        if (!row.eidtForm) {
          row.eidtForm = cloneDeep(dataMap.initFormData)
        }
        row.eidtForm.forEach((item: any) => {
          item.value = row[item.fieldKey] || item.value
        })
        row.isEidt = true
      },
      async handleSave(row: any) {
        try {
          this.handleResolveTempData(row)
          const tempData = Object.assign(row, { contactId: props.contactId })
          if (!row.id) {
            await createContactPay(tempData)
          } else {
            await updateContactPay(row.id, tempData)
          }
          dataMap.isAnyOneEidt = false
          dataMap.getList()
        } catch (err:any) {
          let htmlStr = ''
          err.errors.forEach((item: any, index: number) => {
            htmlStr += `<p>${index + 1}：${item.defaultMessage}</p>`
          })
          ElMessageBox.alert(htmlStr, '提示', {
            cancelButtonText: '关闭',
            dangerouslyUseHTMLString: true,
            cancelButtonClass: 'el-button--danger'
          })
        }
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteContactPayById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSetDefault(row: any) {
        ElMessageBox.confirm(
          '确定设置选中数据为改联系人付款账号吗？',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            setDefaultContactPay(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '设置成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleResolveTempData(tempModel: any) {
        tempModel.eidtForm.forEach((item: any) => {
          tempModel[item.fieldKey] = item.value
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            column.option = dataMap.UserPayTypeOption
              ? dataMap.UserPayTypeOption.map((k: any) => {
                return {
                  ...k,
                  name: k.mark
                }
              })
              : []
          }
        })
      }
    })

    getCompanyContactById(props.contactId).then((res: any) => {
      dataMap.contactDetail = res
    })

    watch(() => props.contactId, () => {
      dataMap.getList()
    })
    onMounted(async() => {
      dataMap.getList()
      await getDropdownByType('UserPayType').then((res: any) => {
        dataMap[`${'UserPayType'}Option`] = res
      })
      dataMap.loadTableSelectOption()
      getDropdownByType('Sex').then((res: any) => {
        dataMap[`${'Sex'}Option`] = res
      })
    })
    return { ...toRefs(dataMap) }
  }

})
</script>
